import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';

export const CLIENT_PJ = 'Clients';

export const TYPOLOGIE_POINT_DE_VENTE = 'PointVente';
export const TYPOLOGIE_ENSEIGNE = 'Enseigne';
export const TYPOLOGIE_GROUPE = 'Groupe';
export const TYPOLOGIE_AUCUN = 'Aucun';

export const TIERS_TYPE_CLIENT = 'Client';
export const TIERS_TYPE_FOURNISSEUR = 'Fournisseur';
export const TIERS_SOUS_TYPE_AFFICHEUR = 'Afficheur';
export const TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON = 'LieuDeLivraison';
export const TIERS_SOUS_TYPE_BAILLEUR_PRO = 'BailleurPro';
export const TIERS_SOUS_TYPE_BAILLEUR_PRIVE = 'BailleurPrive';
export const TIERS_SOUS_TYPE_BAILLEUR_CONCESSION = 'BailleurConcession';
export const TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT = 'FournisseurSupport';
export const TIERS_SOUS_TYPE_CONFRERE = 'Confrere';
export const TIERS_SOUS_TYPE_COLLECTIVITE = 'Collectivite';
export const TIERS_SOUS_TYPE_TECHNICIEN = 'Technicien';
export const TIERS_SOUS_TYPE_CONCURRENT = 'Concurrent';
export const TIERS_SOUS_TYPE_AUCUN = 'Aucun';
export const TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL = 'FournisseurMateriel';
export const TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE = 'BailleurAdminAssimilee';
export const TIERS_SOUS_TYPE_FACTOR = 'Factor';
export const TIERS_SOUS_TYPE_DEMARCHEUR = 'Demarcheur';
export const TIERS_SOUS_TYPE_SERVICE = 'Service';
export const TIERS_SOUS_TYPE_AUTRE = 'Autre';

export const LISTE_TYPOLOGIE = [
  { code: TYPOLOGIE_AUCUN, libelle: '' },
  { code: TYPOLOGIE_POINT_DE_VENTE, libelle: 'detailClient.typologie.pointDeVente' },
  { code: TYPOLOGIE_ENSEIGNE, libelle: 'detailClient.typologie.enseigne' },
  { code: TYPOLOGIE_GROUPE, libelle: 'detailClient.typologie.groupe' },
];

export const LISTE_TYPOLOGIE_FILTRE = [
  { code: TYPOLOGIE_AUCUN, libelle: 'detailClient.typologie.aucun' },
  { code: TYPOLOGIE_POINT_DE_VENTE, libelle: 'detailClient.typologie.pointDeVente' },
  { code: TYPOLOGIE_ENSEIGNE, libelle: 'detailClient.typologie.enseigne' },
  { code: TYPOLOGIE_GROUPE, libelle: 'detailClient.typologie.groupe' },
];

export const LISTE_SOUS_TYPE_WITHOUT_BAILLEUR = [
  { code: TIERS_SOUS_TYPE_AFFICHEUR, libelle: 'fournisseur.sousTypes.afficheur', routeConsultation: 'c.logistique.afficheur' },
  { code: TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON, libelle: 'fournisseur.sousTypes.lieuDeLivraison', routeConsultation: 'c.achat.lieu_de_livraison' },
  { code: TIERS_SOUS_TYPE_CONFRERE, libelle: 'fournisseur.sousTypes.confrere', routeConsultation: 'c.gabed.confrere' },
  { code: TIERS_SOUS_TYPE_TECHNICIEN, libelle: 'fournisseur.sousTypes.technicien', routeConsultation: 'c.logistique.technicien' },
  { code: TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL, libelle: 'fournisseur.sousTypes.fournisseurMateriel', routeConsultation: 'c.gabed.fournisseur_materiel' },
  { code: TIERS_SOUS_TYPE_FACTOR, libelle: 'fournisseur.sousTypes.factor', routeConsultation: 'c.bodac.factor' },
  { code: TIERS_SOUS_TYPE_DEMARCHEUR, libelle: 'fournisseur.sousTypes.demarcheur', routeConsultation: 'c.baux.demarcheur' },
  { code: TIERS_SOUS_TYPE_COLLECTIVITE, libelle: 'fournisseur.sousTypes.collectivite', routeConsultation: 'c.gabed.collectivite' },
  { code: TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT, libelle: 'fournisseur.sousTypes.fournisseurSupport', routeConsultation: 'c.presse.fournisseur_support' },
  { code: TIERS_SOUS_TYPE_AUTRE, libelle: 'fournisseur.sousTypes.autre', routeConsultation: 'c.achat.fournisseurs' },
];

export const LISTE_SOUS_TYPE_BAILLEUR = [
  { code: TIERS_SOUS_TYPE_BAILLEUR_PRO, libelle: 'fournisseur.sousTypes.bailleurPro', routeConsultation: 'c.baux.bailleur' },
  { code: TIERS_SOUS_TYPE_BAILLEUR_PRIVE, libelle: 'fournisseur.sousTypes.bailleurPrive', routeConsultation: 'c.baux.bailleur' },
  { code: TIERS_SOUS_TYPE_BAILLEUR_CONCESSION, libelle: 'fournisseur.sousTypes.concession', routeConsultation: 'c.baux.bailleur' },
  { code: TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE, libelle: 'fournisseur.sousTypes.administrationEtAssimilee', routeConsultation: 'c.baux.bailleur' },
];

export const LISTE_SOUS_TYPE = [
  ...LISTE_SOUS_TYPE_WITHOUT_BAILLEUR,
  ...LISTE_SOUS_TYPE_BAILLEUR,
];

export const LISTE_SOUS_TYPE_UNIQUE = [
  { code: TIERS_SOUS_TYPE_AUCUN, libelle: '', routeConsultation: 'c.bodac.clients/contacts-client' },
];

export const LISTE_SOUS_TYPE_CLIENT = [
  { code: TIERS_SOUS_TYPE_AUCUN, libelle: 'detailClient.sousType.aucun' },
  { code: TIERS_SOUS_TYPE_CONCURRENT, libelle: 'detailClient.sousType.concurrent' },
];

export const MODE_CALCUL_MANUEL = 'Manuel';
export const MODE_CALCUL_FORFAIT = 'Forfait';
export const MODE_CALCUL_POURCENTAGE = 'Pourcentage';

export const LISTE_MODE_CALCUL = [
  { code: MODE_CALCUL_MANUEL, libelle: 'editionClient.honoraire.mode.manuel' },
  { code: MODE_CALCUL_FORFAIT, libelle: 'editionClient.honoraire.mode.forfait' },
  { code: MODE_CALCUL_POURCENTAGE, libelle: 'editionClient.honoraire.mode.pourcentage' },
];

export const LISTE_SOUS_TYPE_FOURNISSEUR_ALL = [
  ...LISTE_SOUS_TYPE_WITHOUT_BAILLEUR,
  ...LISTE_SOUS_TYPE_BAILLEUR,
  ...LISTE_SOUS_TYPE_UNIQUE,
];

export const LISTE_SOUS_TYPE_FOURNISSEURS_PAGES = [
  ...LISTE_SOUS_TYPE_FOURNISSEUR_ALL,
  { code: TIERS_SOUS_TYPE_SERVICE, libelle: 'fournisseur.sousTypes.service' },
].filter((el) => {
  const codes = LISTE_SOUS_TYPE_BAILLEUR.map(el => el.code);
  return !codes.includes(el.code) && !!el.libelle;
});

export const LISTE_SOUS_TYPE_FOURNISSEURS_ACHAT_PAGES = LISTE_SOUS_TYPE_FOURNISSEURS_PAGES
  .filter((el) => el.code !== TIERS_SOUS_TYPE_SERVICE);

export const LISTE_TYPE_MANDAT = [
  { code: 'Normal', libelle: 'detailClient.popupGenerateMandat.normal' },
  { code: 'B2B', libelle: 'detailClient.popupGenerateMandat.b2b' },
];

export const EXPORT_EXCEL_TYPE_BAILLEUR = 'bailleurs';
export const EXPORT_EXCEL_COLLECTIVITE = 'collectivites';
export const EXPORT_EXCEL_CLIENTS = 'clients';
export const EXPORT_EXCEL_CLIENT_ORGANISATIONS = 'clientorganisations';
export const EXPORT_EXCEL_CONTACTS = 'contacts';
export const EXPORT_EXCEL_FOURNISSEURS = 'fournisseurs';
export const EXPORT_EXCEL_COMPTE_TIER = 'comptetier';
export const EXPORT_EXCEL_BALANCE = 'balances';

export const ACTION_MASS_AJOUTER_CONTACT_PORTAIL = 'actionMassAjouterContactPortail';

export const APPLICATION_TVA_TYPE_NORMAL = 'Normal';
export const APPLICATION_TVA_TYPE_EXPORT_HORS_UE = 'ExportHorsUE';
export const APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE = 'Intracommunautaire';
export const APPLICATION_TVA_TYPE_NON_APPLICABLE = 'NonApplicable';

export const LISTE_APPLICATION_TVA = [
  { code: APPLICATION_TVA_TYPE_NORMAL, libelle: 'editionClient.applicationTVAType.normal' },
  { code: APPLICATION_TVA_TYPE_EXPORT_HORS_UE, libelle: 'editionClient.applicationTVAType.exportHorsUE' },
  { code: APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE, libelle: 'editionClient.applicationTVAType.intracommunautaire' },
  { code: APPLICATION_TVA_TYPE_NON_APPLICABLE, libelle: 'editionClient.applicationTVAType.nonApplicable' },
];

export const ACTION_ARCHIVER = 'ACTION_ARCHIVER';
export const ACTION_DESARCHIVER = 'ACTION_DESARCHIVER';
export const ACTION_EDITION_EXTRAIT_COMPTE_TIERS = 'ACTION_EDITION_EXTRAIT_COMPTE_TIERS';

export const FACTURE_CLIENT_STORE_NAME = 'factureClient';

export const TYPE_DONNEE_EXTRAIT_COMPTE_TIERS = 'ExtraitCompte';
export const LISTE_CHOICE_EDITION_TIERS = [
  {
    typeEdition: '',
    libelle: 'popupExtraitCompteTiers.title',
    typeDonnee: TYPE_DONNEE_EXTRAIT_COMPTE_TIERS,
    extentions: [TYPE_PDF, TYPE_DOCX],
    tousProduits: true,
    hasMandatoryDates: true,
  },
];
